import { CircularProgress, Dialog, DialogContent } from "@mui/material";
import { useEffect, useState } from "react";

import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiButton from "components/VuiButton";

import { FaExclamationTriangle } from "react-icons/fa";

const DeleteTemplateDialog = ({ open, onClose, onConfirm, template, loading = false }) => {
  const [step, setStep] = useState(1);

  useEffect(() => {
    if (open) {
      setStep(1);
    }
  }, [open]);

  const handleClose = () => {
    if (loading) return;

    setStep(1);

    onClose?.();
  };

  const handleDelete = () => {
    if (loading) return;

    onConfirm?.(template);
  };

  return (
    <Dialog
      open={open}
      onClose={(e, reason) => {
        if (loading || reason === "backdropClick" || reason === "escapeKeyDown") return;

        handleClose();
      }}
      maxWidth="xs"
      fullWidth
    >
      <DialogContent>
        <VuiBox textAlign="center">
          {step === 2 && (
            <VuiBox mb={2} display="flex" justifyContent="center">
              <VuiBox
                width={60}
                height={60}
                borderRadius="50%"
                display="flex"
                alignItems="center"
                justifyContent="center"
                sx={{
                  background: "rgba(255, 77, 79, 0.15)",
                  border: "1px solid rgba(255, 77, 79, 0.4)",
                }}
              >
                <FaExclamationTriangle size={24} color="#ff4d4f" />
              </VuiBox>
            </VuiBox>
          )}

          <VuiTypography variant="h6" mb={1}>
            {step === 1 ? "Are you sure?" : "Permanent Deletion"}
          </VuiTypography>

          <VuiTypography variant="body2" mb={3} sx={{ fontSize: "14px" }}>
            {step === 1
              ? `Do you want to delete this template?`
              : "This template will be removed from active use. Historical daily operations entries created from this template will become unavailable. This action cannot be undone."}
          </VuiTypography>

          <VuiBox display="flex" justifyContent="center" gap={1.5}>
            <VuiButton
              variant="outlined"
              color="primary"
              size="small"
              disabled={loading}
              onClick={handleClose}
            >
              Cancel
            </VuiButton>

            {step === 1 ? (
              <VuiButton variant="gradient" color="error" size="small" onClick={() => setStep(2)}>
                Yes, Continue
              </VuiButton>
            ) : (
              <VuiButton
                variant="gradient"
                color="error"
                size="small"
                disabled={loading}
                onClick={handleDelete}
              >
                {loading ? (
                  <VuiBox display="flex" alignItems="center" gap={1}>
                    <CircularProgress size={12} />
                    Deleting...
                  </VuiBox>
                ) : (
                  "Delete Template"
                )}
              </VuiButton>
            )}
          </VuiBox>
        </VuiBox>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteTemplateDialog;
